<template>
  <div :class="$vuetify.breakpoint.smAndDown || isInsideCard ? 'list-base' : 'list-base pa-4'">
    <v-card class="mb-5">
        <v-card-title>
            <h3>{{title}}</h3>
          <v-spacer></v-spacer>
          <v-btn v-if="inlineAdd && canCreate" text color="primary" @click="onNewButtonClick()">Agregar</v-btn>
          <slot name="actions"></slot>
        </v-card-title>
        <v-card-text>
          <PaginatedList
            :data-source-url="baseApiUrl"
            :loading-message="loadingMessage"
            :headers="headers"
            :error-message="errorMessage"
            :no-data-message="noDataMessage"
            :no-search-results-message="noSearchResultsMessage"
            :ignore-search-field="ignoreSearchField"
            :default-filters="defaultFilters"
            @itemClick="onItemClick($event.item)"
            :search-dto-url="searchDtoUrl"
            save-search
            :search-key="$options.name"
            :row-actions="actionsComputed"
            @itemAction="onItemAction($event)"
            ref="list"
            :tooltipTextProp="tooltipTextProp"
            :rows-per-page-items="rowsPerPageItems"
            :generarCSV="generarCSV"
            :generarPDF="generarPDF"
            :url-c-s-v="urlCSV"
            :url-p-d-f="urlPDF"
            :is-principal-list="isPrincipalList"
            @getItems="onGetItems($event)"
          ></PaginatedList>
        </v-card-text>
      </v-card>
    <v-btn
      fixed
      dark
      fab
      bottom right
      type="button"
      v-if="canCreate && !inlineAdd"
      title="Nuevo"
      color="secondary"
      @click="onNewButtonClick()"
      id="nuevo_registro">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
  import PaginatedList from "./PaginatedList";
  import permisosMixin from "../mixins/permisosMixin";

  /**
   * Componente base para listas con paginación y ordenamiento
   * en backend
   *
   * Los campos que deben ser reescritos obligatoriamente son:
   *  - data:
   *    - baseApi: string de la URL de la API, a concatenarse luego
   *    de '/api/'. Opcionalmente se puede sobreescribir el método 'getBaseApiUrl'
   *    - headers: Columnas del  data table. Usan las propiedades del Data Table de
   *    Vuetify, con propiedades extras:
   *      - isDate: Poner true si es una fecha
   *      - format(cellValue): Metodo llamado si se desea dar un formato
   *      especial a las celdas de esta columna
   *      - customSortField: Campo que se enviará como query param de orden
   *
   */
  export default {
    name: "ListBase",
    components: {
      PaginatedList
    },
    props: {
      permisoCrear: {
        type: String,
      },
      inlineAdd: {
        type: Boolean,
        default: () => false,
      },
      actions: {
        type: Array,
        default: () => [],
      },
    },
    mixins: [permisosMixin],
    data: () => ({
      elevation: 1,
      list: [],
      headers: [],
      expandedHeaders: [],
      title: "",
      baseApi: "",
      loading: false,
      error: false,
      errorMessage: "No se pudo obtener los registros",
      loadingMessage: "Cargando",
      noDataMessage: "No existen registros cargados",
      noSearchResultsMessage: "Su búsqueda no obtuvo resultados",
      totalPages: null,
      totalCount: null,
      showNewButton: true,
      lastRequest: null,
      tooltipTextProp: null,
      ignoreSearchField: [],
      rowsPerPageItems: [ 5, 10, 25,],
      generarCSV: false,
      generarPDF: false,
      urlCSV: null,
      urlPDF: null,
      isInsideCard: false,
    }),
    methods: {
      getBaseApiUrl() {
        if (!this.baseApi) console.error("Se debe definir baseApi");
        return this.baseApi;
      },
      onNewButtonClick() {
        this.$router.push({ path: "nuevo", append: true }).catch(err => {}).catch(err => {});
      },

      onItemClick(item) {
        this.$router.push({ path: item.id.toString(), append: true }).catch(err => {});
      },

      // eslint-disable-next-line
      onRowClick(itemClicked) {},

      onRowLongClick(itemClicked) {},

      onItemAction(event) {
        this.$emit('itemAction', event);
      },

      update() {
        this.$refs.list.getItems();
      },

      onGetItems(params) {}
    },
    computed: {
      canCreate() {
        return !this.permisoCrear || this.tienePermiso(this.permisoCrear);
      },
      searchDtoUrl() {
        return null;
      },
      baseApiUrl() {
        return this.baseApi;
      },
      listQueryParams() {
        return {};
      },
      defaultFilters() {
        return [];
      },
      isPrincipalList() {
        return false;
      },
      actionsComputed() {
        return this.actions;
      },
    }
  };
</script>

<style>
  tr[disabled] {
    opacity: 0.5;
  }
</style>
